export const FEE_CATEGORIES = [
  { id: "monthlyFees", label: "Monthly Fee" },
  { id: "paraplanning", label: "Paraplanning" },
  { id: "amlChecks", label: "AML Checks" },
  { id: "websiteGraphics", label: "Web & Graphics" },
  { id: "technology", label: "Technology" },
  { id: "miscellaneous", label: "Miscellaneous" },
  { id: "payments", label: "Payments" },
  { id: "advances", label: "Advances" },
  { id: "suspense", label: "Suspense" },
];

const SUMMARY_ONLY_FEE_CATEGORY_IDS = new Set(["payments", "advances"]);

export const STATEMENT_FEE_CATEGORIES = FEE_CATEGORIES.filter(
  ({ id }) => !SUMMARY_ONLY_FEE_CATEGORY_IDS.has(id),
);

const numberValue = (value) => {
  const number = Number(String(value ?? "").replace(/[,£]/g, ""));
  return Number.isFinite(number) ? number : 0;
};

export const statementFeeTotal = (breakdown = {}) =>
  STATEMENT_FEE_CATEGORIES.reduce(
    (total, { id }) => total + numberValue(breakdown?.categories?.[id]),
    0,
  );

export const feeCategoryOf = (chargeType) => ({
  "monthly fees": "monthlyFees",
  paraplanning: "paraplanning",
  "aml checks": "amlChecks",
  "smart search": "amlChecks",
  smartsearch: "amlChecks",
  redflag: "amlChecks",
  "red flag": "amlChecks",
  "website & graphics": "websiteGraphics",
  technology: "technology",
  miscellaneous: "miscellaneous",
  payments: "payments",
  "additional payment": "payments",
  advances: "advances",
  suspense: "suspense",
}[String(chargeType || "").trim().toLowerCase()] || "miscellaneous");

export const feeEntryDescription = (entry = {}) => {
  const manualType = String(entry.manualChargeType || "").trim();
  const isSmartSearch =
    String(entry.manualChargeTypeId || entry.chargeTypeId || "").trim().toLowerCase() ===
      "smartsearch" || manualType.toLowerCase() === "smart search";
  if (!isSmartSearch) {
    return entry.description || manualType || entry.chargeType || "-";
  }
  const seen = new Set();
  return [manualType || "Smart Search", entry.checkType, entry.description]
    .map((part) => String(part || "").trim())
    .filter((part) => {
      const key = part.toLowerCase();
      if (!part || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .join(" - ");
};

export const shouldShowFeeEntryInPdf = (entry = {}) =>
  !(
    feeCategoryOf(entry.chargeType) === "websiteGraphics" &&
    String(entry.description || "").trim().toLowerCase() === "website hosting" &&
    Math.round(numberValue(entry.amountCharged) * 100) === 0
  );

export const buildFeesAndChargesBreakdown = (charges = [], suspenseCharges = []) => {
  const categories = Object.fromEntries(FEE_CATEGORIES.map(({ id }) => [id, 0]));
  charges.forEach((charge) => {
    if (charge.excludeFromBalance === true) return;
    categories[feeCategoryOf(charge.chargeType)] += numberValue(charge.amountCharged);
  });
  suspenseCharges.forEach((charge) => {
    categories.suspense += numberValue(charge.SuspenseCharge);
  });
  return {
    categories,
    total: Object.values(categories).reduce((sum, amount) => sum + amount, 0),
  };
};

export const mergeFeesAndChargesBreakdowns = (breakdowns = []) => {
  const categories = Object.fromEntries(FEE_CATEGORIES.map(({ id }) => [id, 0]));
  breakdowns.forEach((breakdown) => {
    FEE_CATEGORIES.forEach(({ id }) => {
      categories[id] += Number(breakdown?.categories?.[id] || 0);
    });
  });
  return {
    categories,
    total: Object.values(categories).reduce((sum, amount) => sum + amount, 0),
  };
};
